<template>
  <ResponseContainer :loading="!members">
    <h2 v-if="single">Are you attending?</h2>
    <h2 v-else>Who is attending from your party?</h2>
    <div v-for="m in members" :key="m" class="flex flex-col sm:flex-row justify-between items-center border rounded p-4 mb-4">
      <div class="font-bold mb-2 sm:mb-0">{{ m.name }}</div>
      <div class="flex flex-row gap-2 border rounded-full p-1 bg-gray-50">
        <!-- shadow bg-white -->
        <span @click="attending(m.id)" class="rounded-full p-2 px-4 cursor-pointer" :class="{'ring-2 ring-theme-pink/50 shadow bg-white': (m.rsvp ?? true) }">Coming!</span>
        <span @click="notAttending(m.id)" class="rounded-full p-2 px-4 cursor-pointer" :class="{'ring-2 ring-theme-pink/50 shadow bg-white': !(m.rsvp ?? true) }">Can't come</span>
      </div>
    </div>
    <div v-if="group?.additional" class="flex flex-col sm:flex-row gap-2 sm:gap-4 justify-between items-center border rounded p-4 mb-4">
      <div v-if="!plusone" class="font-normal mb-3 sm:mb-0">You have an optional +1</div>
      <input v-else v-model="additional" type="text" name="plusone" placeholder="Full name of your +1" class="mb-0">
      <button v-if="!plusone" @click="plusone = !plusone" class="min-w-fit px-8 py-2 font-normal ring-2 ring-theme-pink/50">Add</button>
      <button v-else @click="saveAdditional(additional); plusone = !plusone" class="min-w-fit px-8 py-2 font-normal ring-2 ring-theme-pink/50">Save</button>
    </div>
    <div class="sm:flex sm:flex-row sm:justify-between">
      <button @click="goToPrevious()" class="secondary-button">← Back</button>
      <button @click="goToNext()">Next →</button>
    </div>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Group from '@/models/group'
import Guest from '@/models/guest'

export default {
  name: 'ResponseEventsPage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
      // expanded: false,
      group: undefined,
      members: undefined,
      single: undefined,
      plusone: false,
      additional: '',
    }
  },
  beforeMount() {
    this.loadParty()
  },
  methods: {
    async loadParty() {
      this.group = await Group.current()
      // Load current RSVP status, otherwise default to attending on display,
      // but keep as `null` locally.
      this.members = await this.group.members
      this.single = this.members.length === 1
    },
    attending(guestId) {
      this.updateResponse(guestId, true)
    },
    notAttending(guestId) {
      this.updateResponse(guestId, false)
    },
    updateResponse(guestId, rsvp) {
      // Save the response immediately so we don't have to batch all later.
      this.members = this.members.map(m => {
        if (m.id === guestId) {
          m.rsvp = rsvp
          m.save()
          return m
        } else {
          return m
        }
      })
    },
    async saveAdditional(name) {
      const one = await Guest.create(name, this.group.id)
      await one.load()
      this.members.push(one)
      this.group.additional = false
      this.group.save()
    },
    goToNext() {
      // Save RSVP responses for all members who still have null, assume null
      // is attending because that's what we default to.
      this.members.forEach(m => {
        if (m.rsvp === null) {
          this.updateResponse(m.id, true)
        }
      })

      // If everyone in the group is not coming, skip to success page.
      if (this.members.every(m => m.rsvp === false)) {
        this.$router.push('/rsvp/success')
      } else {
        this.$router.push('/rsvp/extra')
      }
    },
    goToPrevious() {
      this.$router.push('/rsvp/name')
    },
  },
}
</script>